import React from 'react';

import { DefaultContext } from '@apollo/client';

import { convertDollarsToCents } from '@clearverify/utils';

import {
  InitialBillingRulesDocument,
  InitialBillingUpdate,
  useInitialBillingRulesQuery,
  useInitialBillingRulesUpdateMutation,
} from 'src/api';

const prepareData = (data: UpdateInitialBillingRulesData): UpdateInitialBillingRulesData => {
  return {
    ...data,
    voI: convertDollarsToCents(data.voI) || undefined,
    voE: convertDollarsToCents(data.voE) || undefined,
    revenueShareFlat: convertDollarsToCents(data.revenueShareFlat) || undefined,
    revenueSharePercents: data.revenueSharePercents,
    reverification: convertDollarsToCents(data.reverification) || undefined,
  };
};

export const useInitialBillingRules = () => {
  const { data, loading } = useInitialBillingRulesQuery();

  const [initialBillingRulesUpdateMutation, { loading: updating }] =
    useInitialBillingRulesUpdateMutation();

  const initialBillingRules = React.useMemo(() => {
    return data?.initialBillingList[0];
  }, [data?.initialBillingList]);

  const updateInitialBillingRules = async (params: {
    data: UpdateInitialBillingRulesData;
    context?: DefaultContext;
  }) => {
    const { data, context } = params;
    try {
      const result = await initialBillingRulesUpdateMutation({
        variables: {
          data: prepareData(data),
        },
        refetchQueries: [InitialBillingRulesDocument],
        context,
      });

      return result.data?.updateInitialBillingRules;
    } catch (error) {
      console.error({ error });
      throw error;
    }
  };

  return {
    initialBillingRules,
    loading,
    updateInitialBillingRules,
    updating,
  };
};

type UpdateInitialBillingRulesData = Omit<InitialBillingUpdate, 'id'>;
